import { makeStyles } from '@material-ui/core';
import logo from '../../assets/logo/logo-ld-dark.svg';

const useStyles = makeStyles({
  img: {
    width: 'auto',
    height: 30,
  },
});

// Логотип livedigital для тёмного меню (светлый вариант из vlprojectslive, modules/Branding/livedigital).
const LogoFull = () => {
  const classes = useStyles();

  return <img className={classes.img} src={logo} alt="livedigital" />;
};

export default LogoFull;
